module.exports = __webpack_public_path__ + "static/12-7bbdeb0d66b3123ce011c5da79450e4c.jpg";